
import { FETCH_SERIAL_DETAIL } from '@/store/actions'
import errorHandler from '@/utils/errorHandler'
import { formatTimestamp } from '@/utils/timeUtils'
import { ISerial, OperatorType } from '@/utils/types/model/serial'
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'SerialDetail',
})
export default class SerialDetail extends Vue {
  loading = false

  formatTime(dateStr: string): string {
    return formatTimestamp(dateStr)
  }

  getOperatorTypeLabel(operatorType: OperatorType): string {
    return this.$t(`operator_type_${operatorType}`)
  }

  get serialCode(): string {
    return this.$route.params.id as string
  }

  get serial(): ISerial | null {
    return this.$store.getters.getSerialDetail
  }

  async fetchDetail() {
    try {
      this.loading = true
      await this.$store.dispatch(FETCH_SERIAL_DETAIL, this.serialCode)
    } catch (error) {
      errorHandler(error, {}, true)
    } finally {
      this.loading = false
    }
  }

  goBack() {
    this.$router.back()
  }

  mounted() {
    this.fetchDetail()
  }
}
